import React, { useEffect, useState } from "react";
import { Input, InputDate } from "../../Helpers/Input/Input";
import PhoneInput from "react-phone-input-2";
import trans, { isRTL } from "../../../utils";
import dayjs from "dayjs";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";

function PasswordValidation({ password }) {
	const DEFAULT_COLOR = "#AEB5C1";
	const SUCCESS_COLOR = "#2E9245";
	const ERROR_COLOR = "#CF1322";

	const [validation, setValidation] = useState([
		{
			key: 1,
			title: "Password must be at least 12 characters long",
			color: "#AEB5C1",
			valid: null,
		},
		{
			key: 2,
			title: "Password must contain at least one uppercase letter",
			color: "#AEB5C1",
			valid: null,
		},
		{
			key: 3,
			title: "Password must contain at least one digit",
			color: "#AEB5C1",
			valid: null,
		},
		{
			key: 4,
			title: "Password must contain at least one special character",
			color: "#AEB5C1",
			valid: null,
		},
	]);
	useEffect(() => {
		const updatedValidation = validation.map((rule) => {
			let isValid = null;

			if (password?.length > 0) {
				switch (rule.key) {
					case 1:
						isValid = password.length >= 12;
						break;
					case 2:
						isValid = /[A-Z]/.test(password);
						break;
					case 3:
						isValid = /\d/.test(password);
						break;
					case 4:
						isValid = /[!@#$%^&*(),.?":{}|<>]/.test(password);
						break;
					default:
						isValid = null;
				}
			}

			return {
				...rule,
				valid: isValid,
				color:
					isValid === null
						? DEFAULT_COLOR
						: isValid
							? SUCCESS_COLOR
							: ERROR_COLOR,
			};
		});

		setValidation(updatedValidation);
	}, [password]);

	return (
		<div>
			{validation?.map((i) => (
				<div key={i.key} className="d-flex align-items-center mb-2">
					<span
						style={{
							width: "18px",
							height: "18px",
							borderRadius: "50%",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							fontSize: "10px",
							backgroundColor: i.color,
							marginLeft: isRTL && "6px",
							marginRight: !isRTL && "6px",
						}}
					>
						{i.valid === null ? (
							<CheckOutlined style={{ color: "white" }} />
						) : i.valid ? (
							<CheckOutlined style={{ color: "white" }} />
						) : (
							<CloseOutlined style={{ color: "white" }} />
						)}
					</span>

					<div style={{ color: i.color, fontWeight: "400", fontSize: "12px" }}>
						{trans(i.title)}
					</div>
				</div>
			))}
		</div>
	);
}
export default function UserInfo({ addData }) {
	return (
		<div className="userinfo mb-24">
			<p className="fs-16 fw-700 brand-700 text-uppercase">
				{trans("user info")}
			</p>
			<div className="row">
				<div className="col-lg-6">
					<Input
						title={trans("Name")}
						type="text"
						placeholder={trans("Ex. Ahmed Ali")}
						formstyle="form-input"
						id="name"
						name="name"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						errors={addData.errors.name}
						touched={addData.touched.name}
						value={addData.values.name || ""}
					/>
				</div>
				<div className="col-lg-6">
					<Input
						title={trans("Email")}
						type="email"
						placeholder="Ex@gmail.com"
						formstyle="form-input"
						id="email"
						name="email"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						errors={addData.errors.email}
						touched={addData.touched.email}
						value={addData.values.email || ""}
					/>
				</div>
				<div className="col-lg-12">
					<div className={`position-relative form-input `}>
						<label className="form-label text-capitalize">
							{trans("phone number")}
						</label>
						<div dir="ltr">
							<PhoneInput
								country={"eg"}
								id="phone"
								name="phone"
								disableCountryCode
								countryCodeEditable={true}
								enableSearch={true}
								disableSearchIcon
								onBlur={addData.handleBlur}
								onChange={(value) => addData.setFieldValue("phone", value)}
								value={addData.values.phone || ""}
							/>
						</div>
					</div>
				</div>
				<div className="col-lg-12">
					<Input
						title={trans("Password")}
						type="password"
						placeholder="*********"
						formstyle="form-input"
						id="password"
						name="password"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						errors={addData.errors.password}
						touched={addData.touched.password}
						value={addData.values.password || ""}
					/>
				</div>
				<div className="col-lg-12">
					<Input
						title={trans("Confirm Password")}
						type="password"
						placeholder="*********"
						formstyle="form-input"
						id="confirmPassword"
						name="confirmPassword"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						errors={addData.errors.confirmPassword}
						touched={addData.touched.confirmPassword}
						value={addData.values.confirmPassword || ""}
						disabled={!addData.values.password}
					/>
				</div>
				{<PasswordValidation password={addData.values.password} />}

				{addData?.values?.attributes?.isCustomer && (
					<>
						{" "}
						<div className="col-lg-6">
							<InputDate
								title={trans("Contract start date")}
								id="attributes.contractStartDate"
								name="attributes.contractStartDate"
								onBlur={(value) =>
									addData.setFieldTouched("attributes.contractStartDate", true)
								}
								onChange={(value) =>
									addData.setFieldValue(
										"attributes.contractStartDate",
										value ? dayjs(value).toISOString() : "",
									)
								}
								errors={addData?.errors?.attributes?.contractStartDate}
								touched={addData?.touched?.attributes?.contractStartDate}
								value={addData?.values?.attributes?.contractStartDate || ""}
							/>
						</div>
						<div className="col-lg-6">
							<InputDate
								title={trans("Contract expiry date")}
								id="attributes.contractExpireDate"
								name="attributes.contractExpireDate"
								onBlur={(value) =>
									addData.setFieldTouched("attributes.contractExpireDate", true)
								}
								onChange={(value) =>
									addData.setFieldValue(
										"attributes.contractExpireDate",
										value ? dayjs(value).toISOString() : "",
									)
								}
								errors={addData?.errors?.attributes?.contractExpireDate}
								touched={addData?.touched?.attributes?.contractExpireDate}
								value={addData?.values?.attributes?.contractExpireDate || ""}
								min={
									addData?.values?.attributes?.contractStartDate
										? dayjs(addData?.values?.attributes?.contractStartDate).add(
												1,
												"day",
											)
										: undefined
								}
								disabled={
									addData?.values?.attributes?.contractStartDate ? false : true
								}
							/>
						</div>
						<div className="col-lg-6">
							<InputDate
								title={trans("Expiration Date")}
								id="expirationTime"
								name="expirationTime"
								onBlur={(value) =>
									addData.setFieldTouched("expirationTime", true)
								}
								onChange={(value) =>
									addData.setFieldValue("expirationTime", value)
								}
								errors={addData.errors.expirationTime}
								touched={addData.touched.expirationTime}
								value={addData.values.expirationTime || ""}
							/>
						</div>
					</>
				)}
			</div>
		</div>
	);
}
